import { FormFieldErrorDisplay, WarningIconWithTooltip } from '@commonClient2/components';
import {
    Switch, TextField
} from '@material-ui/core';
import './ToggleNumericSetting.scss';
import { useTranslation } from 'react-i18next';

/**
 * @param {{
 *  toggleName: string;
 *  inputName: string;
 *  toggleValue: boolean;
 *  inputValue: number;
 *  isDisabled: boolean;
 *  isInputDisabled: boolean;
 *  onToggleChange?: *;
 *  onNumberChange?: *;
 *  label: string|undefined;
 *  unitLabel: string|undefined;
 *  showWarning: boolean;
 *  isSetupWithRebidsAllowedExist: boolean
 * }} param0
 */
const ToggleNumericSetting = ({
    toggleName,
    inputName,
    toggleValue,
    inputValue,
    isDisabled,
    isInputDisabled,
    onToggleChange = () => {},
    onNumberChange = () => {},
    label,
    unitLabel,
    showWarning,
    isSetupWithRebidsAllowedExist
}) => {
    const { t } = useTranslation('globalSetup', { keyPrefix: 'managersArchive' });
    return (
        <div className="toggle-numeric-setting">
            <Switch
                checked={toggleValue}
                name={toggleName}
                color="primary"
                onChange={onToggleChange}
                disabled={isDisabled}
            />
            {label}
            <FormFieldErrorDisplay errorMessage={undefined}>
                <>
                    <TextField
                        name={inputName}
                        value={inputValue}
                        inputProps={{
                            min: isSetupWithRebidsAllowedExist ? 1 : 0,
                            required: true,
                            max: 999,
                            style: { textAlign: 'right' },
                        }}
                        type="number"
                        onChange={onNumberChange}
                        disabled={isDisabled || isInputDisabled}
                    />
                    <span className="unit">{unitLabel || ''}</span>
                </>
            </FormFieldErrorDisplay>
            {
                (showWarning) && (
                    <WarningIconWithTooltip
                        tooltipWarnings={[t('managerAutoArchiveBidsWarning')]}
                        fontSize="medium"
                    />
                )
            }
        </div>
    );
};

export default ToggleNumericSetting;
